module.exports = __webpack_public_path__ + "img/restaurant-color.f7793228.svg";